var _circle, _path, _line, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 240,
    viewBox: "0 0 350 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 264,
    cy: 100,
    r: 25,
    stroke: "currentColor",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M316 201H324C324 167.863 297.137 141 264 141C230.863 141 204 167.863 204 201H212C212 172.281 235.281 149 264 149C292.719 149 316 172.281 316 201Z",
    fill: "currentColor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 204,
    y1: 197,
    x2: 318,
    y2: 197,
    stroke: "currentColor",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 93H66",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 115H81",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 153L102 153",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 171L142 171",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.504 64H36C30.4772 64 26 68.4771 26 74V191C26 196.523 30.4772 201 36 201H168C173.523 201 178 196.523 178 191V142.359C175.394 142.917 172.723 143.339 170 143.615V191C170 192.105 169.105 193 168 193H36C34.8954 193 34 192.105 34 191V74C34 72.8954 34.8954 72 36 72H102.272C103.43 69.222 104.849 66.5483 106.504 64Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M209 93.5C209 122.858 183.898 147 152.5 147C121.102 147 96 122.858 96 93.5C96 64.142 121.102 40 152.5 40C183.898 40 209 64.142 209 93.5Z",
    stroke: "currentColor",
    strokeWidth: 8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.393 84L151.879 99.0094",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.795 99.4141L140.999 91.7645",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M151 56V60.5",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M188 93H192.5",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111 93H115.5",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151 127V131.5",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.530d2cb5c91e2154ca74c4d7dffec535.svg";
export { ForwardRef as ReactComponent };